/**
 * useTutorCoachingVideosState — les deux gestes de « Vidéos de formation » : le retour (la pile, sinon
 * la coquille), et « Formation du tuteur » → `tutor/formation`, comme `TutorVideos.js`.
 */
import { useNavigation } from "@react-navigation/native"

import { useBackOr } from "../../../hooks/useBackOr"

type StackNavigation = { push: (route: string) => void }

export function useTutorCoachingVideosState() {
    const navigation = useNavigation() as unknown as StackNavigation
    return {
        onBack: useBackOr("menu"),
        onOpenTraining: () => navigation.push("tutor/formation"),
    }
}
